import React, { Fragment } from 'react';
import { TableCell, TableRow, makeStyles } from '@material-ui/core';
import { ISkeletonContent } from './types';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
    tableCell: {
        paddingTop: 5,
        paddingBottom: 5,
        paddingRight: 3,
        paddingLeft: 3,
        height: 56.4,
        maxWidth: 18,
        width: 18,
    },
}));

export const SkeletonContent = ({
    columns,
    size,
    canDelete,
}: ISkeletonContent) => {
    const classes = useStyles();

    return (
        <Fragment>
            {Array.from({ length: size }).map((_, key) => (
                <TableRow hover key={key}>
                    {canDelete && (
                        <TableCell padding="checkbox">
                            <Skeleton variant="rect" width="100%" height={40} />
                        </TableCell>
                    )}

                    {columns.map((column, key) => (
                        <TableCell
                            key={key}
                            style={{
                                maxWidth: column.width || 'inherit',
                                width: column.width || 'inherit',
                            }}
                            className={classes.tableCell}
                        >
                            <Skeleton
                                variant="rect"
                                width={'100%'}
                                height={40}
                            />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </Fragment>
    );
};
